import {
  Box,
  Button,
  DialogActions,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import WhatsConfigData from "./WhatsConfigData";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router-dom";
import VerifyToken from "./VerifyToken";
import { useFetch, useNotificationContext } from "@4uhub/lib4uhub";
import TicketServService from "../../services/ticket.service";
import { useCallback } from "react";

const translationPath = "chatBot.page.register.ticketServiceWhats.";
const ticketService = new TicketServService();

const WhatsappApiConfigs = ({
  verifyToken,
  openWhatsappBusinesProfileModalHandler,
  openWhatsappNameModalHandler,
}: {
  verifyToken: string;
  openWhatsappBusinesProfileModalHandler: () => void;
  openWhatsappNameModalHandler: () => void;
}) => {
  const { t } = useTranslation();
  const { ticketServiceId } = useParams();
  const [searchParams] = useSearchParams();
  const ticketMessageReceivedEventCode = searchParams.get(
    "ticketMessageReceivedEventCode",
  );
  const { setMessage } = useNotificationContext();

  var receivedEventoCode = parseInt(ticketMessageReceivedEventCode || "0");
  var aux =
    receivedEventoCode > 10 ? "-" + Math.ceil(receivedEventoCode / 10) : "";
  let link = `https://api.dev.4uhub.com.br/whatsapp${aux}/api/v1/Webhook/${ticketServiceId}`;
  if (process.env.REACT_APP_ENVIRONMENT === "homolog")
    link = `https://whatsapp.hml.4uhub.com.br/api/v1/Webhook/${ticketServiceId}`;
  if (process.env.REACT_APP_ENVIRONMENT === "production")
    link = `https://whatsapp${aux}.4uhub.com.br/api/v1/Webhook/${ticketServiceId}`;

  const { sendRequest: updateWebhook, loading: loadingUpdateWebhook } =
    useFetch(ticketService.webhookUpdate);

  const {
    sendRequest: registerPhoneNumber,
    loading: loadingRegisterPhoneNumber,
  } = useFetch(ticketService.registerPhoneNumber);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const onRegisterNumber = useCallback(async () => {
    if (ticketServiceId) {
      const { data, success } = await registerPhoneNumber({
        ticketServiceId,
      });
      if (success && data && data.success) {
        setMessage({
          message: t(translationPath + "phone_number_registered"),
        });
      } else {
        setMessage({
          message: t(translationPath + "errors.phone_number_registered"),
          type: "error",
        });
      }
    }
  }, [registerPhoneNumber]);

  const onUpdateWebhook = useCallback(async () => {
    if (ticketServiceId) {
      const { data, success } = await updateWebhook({
        ticketServiceId,
      });
      if (success && data && data.success) {
        setMessage({
          message: t(translationPath + "webhook_updated"),
        });
      } else {
        setMessage({
          message: t(translationPath + "errors.webhook_updated"),
          type: "error",
        });
      }
    }
  }, [updateWebhook]);

  return (
    <Grid
      item
      sm={12}
      pl={2}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"start"}
      sx={(theme) => ({
        width: "100%",
        maxWidth: matches ? 300 : undefined,
        backgroundColor:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        borderRadius: 1,
      })}
    >
      <Box
        display={"flex"}
        flexDirection={matches ? "column" : "row"}
        alignItems={matches ? "start" : "center"}
      >
        <Typography
          mr={matches ? 0 : 2}
          sx={(theme) => ({
            color:
              theme.palette.mode === "light"
                ? theme.palette.grey[600]
                : theme.palette.grey[200],
          })}
        >
          {t(translationPath + "webhook_link")}:
        </Typography>
        <WhatsConfigData
          tooltipTilte={t(translationPath + "webhook_link_tooltip")}
          data={link}
        />
      </Box>
      {verifyToken.length !== 0 && <VerifyToken verifyToken={verifyToken} />}
      <Box
        display={"flex"}
        flexDirection={matches ? "column" : "row"}
        alignItems={matches ? "start" : "center"}
      >
        <DialogActions>
          <Button
            variant="contained"
            onClick={onUpdateWebhook}
            disabled={loadingUpdateWebhook}
          >
            {t(translationPath + "button_update_webhook")}
          </Button>
          <Button
            variant="contained"
            onClick={onRegisterNumber}
            disabled={loadingRegisterPhoneNumber}
          >
            {t(translationPath + "button_register_phone_number")}
          </Button>
          <Button
            variant="outlined"
            onClick={openWhatsappBusinesProfileModalHandler}
          >
            {t(translationPath + "button_business_profile")}
          </Button>
          <Button variant="outlined" onClick={openWhatsappNameModalHandler}>
            {t(translationPath + "button_phone_profile")}
          </Button>
        </DialogActions>
      </Box>
    </Grid>
  );
};

export default WhatsappApiConfigs;
